export const AUTH_TOKEN_INVALID = 'invalid_token';
export const AUTH_TOKEN_BANNED = 'token_error';
export const AUTH_REFRESH_TOKEN_EVENT = 'refresh_token';
